import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from '../../hooks/useAuth';

export const ProtectedRoute = ({ children }:any) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};